import { httpDelete, httpGet, httpPatch, httpPost } from "../connection";

export async function getEvidenceProgress() {
  return await httpGet(`/evidence-progress`);
}

export async function createEvidenceProgress(values: {
  progress_name: string;
}) {
  return await httpPost(`/evidence-progress`, values);
}

export async function updateEvidenceProgress(
  progress_id: number,
  values: { progress_name?: string; progress_order?: number } = {}
) {
  return await httpPatch(`/evidence-progress/${progress_id}`, values);
}

export async function deleteEvidenceProgress(
  id: number,
  options = { replace: null }
) {
  if (options.replace == null)
    return await httpDelete(`/evidence-progress/${id}`);
  else if (options.replace != null)
    return await httpDelete(
      `/evidence-progress/${id}?replace=${options.replace}`
    );
}

const EvidenceProgressApi = {
  getEvidenceProgress,
  createEvidenceProgress,
  updateEvidenceProgress,
  deleteEvidenceProgress,
};

export default EvidenceProgressApi;
